import React from "react";

const Button = ({ text, onClick, disabled, newWidth }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="relative flex items-center justify-center  text-black py-2 px-4 rounded-full  transition-all duration-300 hover:opacity-80 focus:outline-none h-[53px]  disabled:opacity-60"
      style={{
        width: newWidth ? newWidth : "320px", // Increased button width
        background:
          "linear-gradient(90deg, #C57D00 20%, #DF9D25 42%, #E5B04D 45%, #EECC88 50%, #F6E2B7 54%, #FBF2D9 57%, #FEFBEE 60%, #FFFFF5 62%, #E1A433 74%, #DF9D25 92%)",
      }}
    >
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background:
            "linear-gradient(0deg, #FFE98B 0%, #EAB647 28%, #DF9D25 44%, #C58D21 76%, #C28A20 83%, #B9811D 88%, #AA7217 92%, #945C0F 96%, #794004 100%, #763D03 100%)",
          zIndex: 0,
        }}
      ></div>
      <span className="relative z-10 text-black text-[18.63px] font-bold leading-[25.62px]">
        {text}
      </span>
    </button>
  );
};

export default Button;
